import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import * as zephyr from './zephyr';
import * as tios from './tios';

export default class SocketEventNode extends BaseNode {
    constructor() {
        super();
        this.name = 'On Socket Connection Event';
        this.id = 'node_socket_event';
        this.linkedFeature = 'socket';

        this.outputs = [
            {
                name: 'Connection Event',
                portId: 'sock_connection_event',
                params: [],
            },
        ];

        const settings: Setting[] = [
            {
                id: 'SOCKET',
                name: 'Socket',
                settingType: SettingType.OPTION,
                refId: 'socket_connection',
                required: true,
                default: '',
                options: [],
            },
            {
                id: 'EVENT_TYPE',
                name: 'Event Type',
                settingType: SettingType.OPTION,
                required: true,
                default: 'CONNECTED',
                options: [
                    {
                        value: 'CONNECTED',
                        name: 'Connected',
                    },
                    {
                        value: 'DISCONNECTED',
                        name: 'Disconnected',
                    },
                ],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getSettingValue(settingId: string): string {
        if (settingId === 'DISPLAY_NAME') {
            const project: ProjectConfiguration = this.project;
            const value = super.getSettingValue(settingId);
            if (value !== '') {
                return value;
            }
            const SOCKET = project.getFeature(this.getSettingValue('SOCKET'));
            const EVENT_TYPE = this.getSettingValue('EVENT_TYPE');
            if (SOCKET) {
                return `On SOCKET ${SOCKET.getSettingValue('NAME')} ${EVENT_TYPE}`;
            }
        }
        return super.getSettingValue(settingId);
    }

    getName(): string {
        const project: ProjectConfiguration = this.project;
        const SOCKET = project.getFeature(this.getSettingValue('SOCKET'));
        if (SOCKET) {
            const EVENT_TYPE = this.getSettingValue('EVENT_TYPE');
            return `On SOCKET ${SOCKET.getSettingValue('NAME')} ${EVENT_TYPE}`;
        }
        return super.getName();
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'zephyr':
                return zephyr.getCodeBlocks(this);
            case 'tios':
                return tios.getCodeBlocks(this);
            default:
                return [];
        }
    }
}
